// extracted by mini-css-extract-plugin
module.exports = {"itemsPerPage":"glqcCX-ZysYUy3t7Fu6WH"};